import { useMemo } from "react";
import { useDashboardMetrics } from "@/domains/appointment/appointments/hooks/use-dashboard-metrics";

export interface AppointmentTabCounts {
  today: number;
  incoming: number;
  requests: number;
}

/**
 * Hook to extract appointment counts for tab indicators
 * Uses dashboard metrics for today, incoming, and requests counts
 */
export const useAppointmentTabCounts = (): AppointmentTabCounts => {
  const { data: dashboardMetrics, loading: metricsLoading } = useDashboardMetrics();

  const counts = useMemo((): AppointmentTabCounts => {
    return {
      today: metricsLoading ? 0 : dashboardMetrics?.tabs?.today || 0,
      incoming: metricsLoading ? 0 : dashboardMetrics?.tabs?.incoming || 0,
      requests: metricsLoading ? 0 : dashboardMetrics?.tabs?.requests || 0,
    };
  }, [
    dashboardMetrics?.tabs?.today,
    dashboardMetrics?.tabs?.incoming,
    dashboardMetrics?.tabs?.requests,
    metricsLoading,
  ]);

  return counts;
};
